import { Hourglass } from "lucide-react";
import { useTranslation } from "react-i18next";
import { StepHeading } from "../OnboardingShell";
import { PrimaryButton } from "../ui/buttons";

interface InviteWaitingStepProps {
  employeesCount: number;
  teamsCount: number;
  onGoToApp: () => void;
}

/**
 * Step 6 before activation: the onboarding is complete, the Graftus team
 * activates Intelligence (sales-led), and the invitation is sent from here
 * afterwards (the dashboard banner brings the admin back).
 */
export function InviteWaitingStep({ employeesCount, teamsCount, onGoToApp }: InviteWaitingStepProps) {
  const { t } = useTranslation("onboarding");
  const steps = t("invite.waiting.steps", { returnObjects: true }) as string[];
  return (
    <div data-testid="onboarding-invite-waiting">
      <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-g-pill bg-g-warning-tint text-g-warning" aria-hidden="true">
        <Hourglass className="h-6 w-6" />
      </div>
      <StepHeading
        title={t("invite.waiting.title")}
        lead={t("invite.waiting.lead", { n: employeesCount, teams: teamsCount })}
      />
      <h2 className="mb-2 text-[13px] font-bold uppercase tracking-wide text-g-ink-500">{t("invite.waiting.next")}</h2>
      <ol className="mb-8 flex flex-col gap-2">
        {steps.map((step, index) => (
          <li key={step} className="flex items-start gap-3 text-[14px] text-g-ink-700">
            <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-g-pill bg-g-primary-tint text-[12px] font-bold text-g-primary" aria-hidden="true">
              {index + 1}
            </span>
            {step}
          </li>
        ))}
      </ol>
      <PrimaryButton onClick={onGoToApp}>{t("invite.waiting.cta")}</PrimaryButton>
    </div>
  );
}
